import Link from "next/link";
import React from "react";
import styled from "styled-components";
import TextWithArrow from "./TextWithArrow";

export const PaginationContainer = styled.div<{ mobileTopSpacing?: boolean }>`
  display: flex;
  justify-content: space-between;
  
  a {
    text-decoration: none;
  }
  
  ${(props) =>
    props.theme.apply(
      props.mobileTopSpacing ? "default" : ["desktop", "screen"],
      (breakpoint: string) => {
        return `
        margin-top: ${props.theme.spacePx(breakpoint, 5)};
        
        `;
      }
    )}
`;

export const Pagination = ({
  paginationBaseUrl,
  page,
  postTotal,
  pageTotal,
  firstPageShowMore = "NEXT",
  mobileTopSpacing,
  shallowRouting,
}: {
  paginationBaseUrl: string;
  firstPageShowMore: string;
  page: number;
  postTotal: number;
  pageTotal: number;
  mobileTopSpacing?: boolean;
  shallowRouting?: boolean;
}) => {
  if (pageTotal === 1) return <></>;

  return (
    <PaginationContainer mobileTopSpacing={mobileTopSpacing}>
      <div>
        {page > 1 && (
          <Link
            href={`${paginationBaseUrl}${page - 1}`}
            shallow={!!shallowRouting}
          >
            <a title="load previous page">
              <TextWithArrow align="left" heading="h3" size={8}>
                PREVIOUS
              </TextWithArrow>
            </a>
          </Link>
        )}
      </div>
      <div>
        {page < pageTotal && (
          <Link
            href={`${paginationBaseUrl}${page + 1}`}
            shallow={!!shallowRouting}
          >
            <a title="load next page">
              <TextWithArrow align="right" heading="h3" size={8}>
                {page === 1 && firstPageShowMore ? firstPageShowMore : "NEXT"}
              </TextWithArrow>
            </a>
          </Link>
        )}
      </div>
    </PaginationContainer>
  );
};
